// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"d51de9de","171":"6c5b02bb","432":"fce3571d","994":"c3bbae98"}[chunkId] + ".chunk.js";
};